import { useEffect, useRef, useState } from "react";
import {
  catchError,
  from,
  interval,
  map,
  of,
  startWith,
  Subject,
  switchMap,
  takeUntil,
} from "rxjs";
import IcNotificationIcon from "../../images/ic_notification_icon_new.svg";
import {
  HTTP_METHODS,
  NOTIFICATION_POOL_INTERVAL,
} from "../../utils/constants";
import { networkBackendRequest } from "../../utils/networkUtils";
import { RequestState } from "../../utils/request.model";
import {
  NotificationCount,
  NotificationPositionAbs,
} from "../AdminDocumentValidation/AdminDocumentValidationStyles";
import { ButtonNotification } from "../AdminDocumentValidation/CommonButtonNotification";
import { SidebarNotifications } from "../Notifications/SidebarNotifications";

type CounterState = RequestState<any>;
export const NewNotifications = () => {
  const [showModalNotifications, setShowModalNotifications] = useState(false);
  const [countState, setCountState] = useState<CounterState>({});

  const destroy$Ref = useRef(new Subject<void>());
  const destroy$ = destroy$Ref.current;

  const loadCountNotification$Ref = useRef(new Subject<void>());
  const loadCountNotification$ = loadCountNotification$Ref.current;

  useEffect(() => {
    loadCountNotification$
      .pipe(
        takeUntil(destroy$),
        startWith(null),
        switchMap(() => {
          const request = networkBackendRequest(
            "/notifications/count/",
            HTTP_METHODS.GET,
            null
          ).then((response) => response.json());

          return from(request).pipe(
            map((data) => {
              return { status: "SUCCESS", data };
            }),
            catchError((error) => {
              return of({ status: "FAILED", error });
            })
          );
        })
      )
      .subscribe((countState) => {
        setCountState(countState as any);
      });
  }, [destroy$, loadCountNotification$]);

  useEffect(() => {
    interval(NOTIFICATION_POOL_INTERVAL)
      .pipe(takeUntil(destroy$))
      .subscribe(() => {
        loadCountNotification$.next();
      });
  }, [loadCountNotification$, destroy$]);

  useEffect(() => {
    return () => {
      destroy$.next();
      destroy$.complete();
    };
  }, [destroy$]);

  return (
    <>
      {showModalNotifications && (
        <SidebarNotifications
          loadCountNotification$={loadCountNotification$}
          countState={countState.data}
          onOutsideClick={() => {
            setShowModalNotifications(false);
          }}
        />
      )}
      <div
        className="width-height"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          width: "100%",
          position: "absolute",
        }}
      >
        <div
          onClick={() => {
            if (countState.status === "SUCCESS") {
              setShowModalNotifications(true);
            }
          }}
        >
          <NotificationPositionAbs width="27rem" style={{ cursor: "pointer" }}>
            <NotificationCount>{countState.data?.count} </NotificationCount>
            <div style={{ width: "6rem" }} />
          </NotificationPositionAbs>
          <ButtonNotification>
            <img
              src={IcNotificationIcon}
              width="50"
              height="50"
              alt="Processing request"
              style={{ marginRight: "1rem" }}
              className="img-notification"
            />
            Notificaciones
          </ButtonNotification>
        </div>
        <div style={{ width: "6rem" }} />
      </div>
    </>
  );
};
